



















import {
  computed,
  defineComponent,
  PropType,
  toRefs,
  useRoute,
  useRouter
} from '@nuxtjs/composition-api'
import { SideHeaderMenu } from './SideHeader.vue'

export default defineComponent({
  props: {
    menuEntry: {
      type: Object as PropType<SideHeaderMenu>,
      required: true
    }
  },
  setup(props) {
    const { menuEntry } = toRefs(props)
    const router = useRouter()
    const route = useRoute()

    const href = computed(() => {
      return router.resolve({
        name: menuEntry.value.routeName
      }).href
    })

    const pageIsActive = computed(() => {
      return route.value.name?.startsWith(menuEntry.value.routeName)
    })
    return {
      href,
      pageIsActive
    }
  }
})
